import axiosInstance from './axiosInstance';

const billingService = {
  // billing_status: PENDING (se puede facturar), INVOICED o VOID; sin él, todos
  listarDespachos: async (params) => {
    const response = await axiosInstance.get('/dispatches', { params });
    return response.data;
  },

  // Lo que salió en el despacho, sin precios
  obtenerDespacho: async (id) => {
    const response = await axiosInstance.get(`/dispatches/${id}`);
    return response.data;
  },

  // Lo que imprime la constancia fitosanitaria, armado en el servidor
  obtenerFitoPdf: async (id) => {
    const response = await axiosInstance.get(`/dispatches/${id}/fito-pdf`);
    return response.data;
  },

  listarFacturas: async (params) => {
    const response = await axiosInstance.get('/invoices', { params });
    return response.data;
  },

  obtenerFactura: async (id) => {
    const response = await axiosInstance.get(`/invoices/${id}`);
    return response.data;
  },

  // Todo lo que imprime el PDF, armado en el servidor
  obtenerFacturaPdf: async (id) => {
    const response = await axiosInstance.get(`/invoices/${id}/pdf`);
    return response.data;
  },

  crearFactura: async (dispatchIds) => {
    const response = await axiosInstance.post('/invoices', { dispatch_ids: dispatchIds });
    return response.data;
  },

  // Una factura por despacho, todas o ninguna
  crearFacturasSeparadas: async (dispatchIds) => {
    const response = await axiosInstance.post('/invoices/separate', { dispatch_ids: dispatchIds });
    return response.data;
  },

  obtenerBalanceCliente: async (clientId) => {
    const response = await axiosInstance.get(`/invoices/client/${clientId}/balance`);
    return response.data;
  },

  anularFactura: async (id) => {
    const response = await axiosInstance.patch(`/invoices/${id}/void`);
    return response.data;
  },

  // details = [{ invoice_detail_id, quantity_entered, unit_entered }]
  crearBaja: async (data) => {
    const response = await axiosInstance.post('/credit-notes', data);
    return response.data;
  },

  anularBaja: async (id) => {
    const response = await axiosInstance.patch(`/credit-notes/${id}/void`);
    return response.data;
  },
};

export default billingService;
